export default __webpack_public_path__ + "static/media/400_ml_e.80e78911.svg";